import { Grid, ListItem, ListItemText, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

export type OpcoesTransferenciaType = 'EQUIPE' | 'ATENDENTE';

type OpcoesTransferenciaProps = {
  onSelect: (opcao: OpcoesTransferenciaType) => void;
};

const useStyles = makeStyles(({ palette }) => ({
  card: {
    height: '100%',
    color: palette.text.primary,
    backgroundColor: palette.background.tertiary,
  },
}));

export default function OpcoesTransferencia(props: OpcoesTransferenciaProps) {
  const { onSelect } = props;
  const classes = useStyles();

  const handleClick = (opcao: OpcoesTransferenciaType) => {
    onSelect(opcao);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography color="textSecondary" variant="body2">
          Para onde você quer transferir?
        </Typography>
      </Grid>

      <Grid item xs>
        <ListItem
          className={classes.card}
          onClick={() => handleClick('EQUIPE')}
          button
        >
          <ListItemText
            primary="Equipe"
            secondary="Transfira para qualquer uma das equipes disponíveis."
            primaryTypographyProps={{ variant: 'body2' }}
            secondaryTypographyProps={{ variant: 'caption' }}
          />
        </ListItem>
      </Grid>

      <Grid item xs>
        <ListItem
          className={classes.card}
          onClick={() => handleClick('ATENDENTE')}
          button
        >
          <ListItemText
            primary="Atendente"
            secondary="Transfira para outro atendente que esteja disponível."
            primaryTypographyProps={{ variant: 'body2' }}
            secondaryTypographyProps={{ variant: 'caption' }}
          />
        </ListItem>
      </Grid>
    </Grid>
  );
}
